export default __webpack_public_path__ + "static/media/arrow-right.5c1534d8.svg";